var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"card-body",class:{'is-foot': _vm.foot, 'is-padded': _vm.padded, 'is-grow': _vm.grow}},[_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }